export default class Certificates {
  static safe(endpoint) {
    return endpoint
      .split(' ')
      .map(function(item) {
        return item.charAt(0).toUpperCase() + item.substring(1);
      })
      .join('');
  }
  static get List() {
    return Certificates._list.map(obj => {
      return {
        ...obj,
        listAction: `listCertificate${Certificates.safe(obj.title)}`,
        listProperty: `certificate${Certificates.safe(obj.title)}s`
      };
    });
  }
  static get _list() {
    return [
      { slug: 'badminton', title: 'badminton' },
      { slug: 'baseball', title: 'baseball' },
      { slug: 'basketball', title: 'basketball' },
      { slug: 'cross country', title: 'cross country' },
      { slug: 'field hockey', title: 'field hockey' },
      { slug: 'football', title: 'football' },
      { slug: 'golf', title: 'golf' },
      { slug: 'gymnastics', title: 'gymnastics' },
      { slug: 'lacrosse', title: 'lacrosse' },
      { slug: 'roller hockey', title: 'roller hockey' },
      { slug: 'soccer', title: 'soccer' },
      { slug: 'softball', title: 'softball' },
      { slug: 'swimming', title: 'swimming' },
      { slug: 'tennis', title: 'tennis' },
      { slug: 'track & field', title: 'track and field' },
      { slug: 'volleyball', title: 'volleyball' },
      { slug: 'water polo', title: 'water polo' },
      { slug: 'wrestling', title: 'wrestling' }
    ];
  }
}
